import { Injectable } from '@angular/core';
import { TrackObject } from '../asp/TrackObject';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { AroTrackComponent } from './aro-track.component';

@Injectable({
  providedIn: 'root'
})

export class AroTrackService {

  private dialogRef: MatDialogRef<any>;

  private dialogRefArr: MatDialogRef<any>[] = [];

  constructor(private dialog: MatDialog) { }

  showTrack(track: TrackObject) {
    this.dialogRef = this.getFromArr(track.trackID);
    if (this.dialogRef && this.dialogRef.getState() == MatDialogState.OPEN) {
      let trackComp = this.dialogRef.componentInstance as AroTrackComponent;
      trackComp.setTrack(track);
      trackComp.dialogRaise()
    }
    else {
      this.dialogRef = this.dialog.open(AroTrackComponent, AroTrackComponent.createDialogConfig(track));
      this.dialogRefArr.push(this.dialogRef);
      let trackComp = this.dialogRef.componentInstance as AroTrackComponent;
      trackComp.setTrack(track);
      trackComp.dialogRaise();
    }
  }

  getFromArr(num: any): any {
    let Ref: MatDialogRef<any> = null;
    this.removeGarbage();

    this.dialogRefArr.forEach((ref) => {
      let refTrackAro = ref.componentInstance as AroTrackComponent;
      if (refTrackAro) {
        if (num == refTrackAro.caspID) {
          Ref = ref;
          return;
        }
      }
    })
    return Ref;
  }

  removeGarbage() {
    this.dialogRefArr = this.dialogRefArr.filter(ele => {
      return(ele != null && ele !== undefined && ele.getState() != MatDialogState.CLOSED);
    })
  }
}
